import { render } from "./storeView.vue?vue&type=template&id=64b5e0bf&scoped=true"
import script from "./storeView.vue?vue&type=script&lang=js"
export * from "./storeView.vue?vue&type=script&lang=js"

import "./storeView.vue?vue&type=style&index=0&id=64b5e0bf&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b5e0bf"]])

export default __exports__